import { change, actionTypes } from 'redux-form'

export default ({ dispatch }) => next => action => {
  if (action.type === actionTypes.UNREGISTER_FIELD) {
    const isFieldArray = /.*\[\d+\]\..*/.test(action.payload.name)
    !isFieldArray && dispatch(change(action.meta.form, action.payload.name, null))
  }
  next(action)
}
